import React from 'react';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';
import project1Image from '../../assets/Portfolio/LogoPanal.png'; // Import your images
import project2Image from '../../assets/ShephedLaw/MainCaseStudiesPhoto.jpg';
import project3Image from '../../assets/Portfolio/LogoPanal4.jpg';


function WebDesignPortfolio() {
  const boxWidth = "w-full";
  const boxHeight = "h-full";

  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1 ]">
    <title>SEO & Web Design Case Studies | Women-Led Brand Transformations | Her Growth Co.</title>
<meta
name="description"
content="See how we’ve helped female founders grow their visibility, authority, and income with expert design and strategic SEO."
/>
<meta
name="keywords"
content="real results for women-owned brands, female-led business transformations, SEO and design success stories, branding results for founders, case studies for premium consultants, client growth journeys, feminine web redesign outcomes, authentic visibility success"
/>


    <section className='bg-[#7F7E75]'>
      <Navbar />

      {/* Hero Section */}
      <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20 bg-[#7F7E75]">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <div className="flex items-center rounded-md px-3 py-1">
            <p className="text-sm uppercase mb-12">Our Case Studies</p>
          </div>
          <h2 className="text-3xl font-regular md:text-5xl uppercase mb-20">
            Our <span className='italic text-black bg-[#CFF098]'>Design Showcase</span>
          </h2>
          <p className="text-lg text-gray-300 max-w-xl mb-10">
            Explore a selection of our website design projects. More coming soon!
          </p>
        </div>

        {/* Portfolio Items */}
        <ul className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4">




          {/* Project 2 */}
          <li className={`border-black border-[1px] bg-white p-8 md:p-10 flex flex-col items-center justify-between ${boxWidth} ${boxHeight}`}>
            <div className="flex items-center justify-center mb-4">
              <img src={project2Image} alt="Project 2 - Her Growth Co" className="w-32 h-32 object-cover rounded-md" />
            </div>
            <p className="mb-3 text-2xl font-semibold text-black text-center uppercase italic">
              Full Custom Website
            </p>
            <p className="text-black text-center text-thin w-[350px] text-xl mb-10 font-light">
              Using WordPress we build a fully customized website for Shepherd Law.
            </p>
            <div className="mt-4">
            <a href='/shephedlaw'>
              <span className="bg-[#CFF098] text-black font-thin py-1 px-3 rounded-full text-sm text-bold">View Now!</span>
              </a>
            </div>
          </li>


          {/* Project 1 */}
          <li className={`border-black border-[1px] bg-white p-8 md:p-10 flex flex-col items-center justify-between ${boxWidth} ${boxHeight}`}>
            <div className="flex items-center justify-center mb-4">
              <img src={project1Image} alt="Project 1 - Her Growth Co" className="w-32 h-32 object-cover rounded-md" />
            </div>
            <p className="mb-3 text-2xl font-semibold text-black text-center uppercase italic">
              SEO Local Audit
            </p>
            <p className="text-black text-center text-thin w-[350px] text-xl mb-10 font-light">
            We ranked this client #1 On Google-My-Business.
            </p>
            <div className="mt-4">
              <span className="bg-[#CFF098] text-black font-thin py-1 px-3 rounded-full text-sm ">Coming Soon</span>
            </div>
          </li>


          {/* Project 3 */}
          <li className={`border-black border-[1px] bg-white p-8 md:p-10 flex flex-col items-center justify-between ${boxWidth} ${boxHeight}`}>
            <div className="flex items-center justify-center mb-4">
              <img src={project3Image} alt="Project 3 - Her Growth Co" className="w-32 h-32 object-cover rounded-md" />
            </div>
            <p className="mb-3 text-2xl font-semibold text-black text-center uppercase italic">
              Rebranding Web Redesign
            </p>
            <p className="text-black text-center text-thin w-[350px] text-xl mb-10 font-light">
              We rebranded this brand and redesigned their website.
            </p>
            <div className="mt-4">
              <span className="bg-[#CFF098] text-black font-thin py-1 px-3 rounded-full text-sm">Coming Soon</span>
            </div>
          </li>
        </ul>
      </div>
      <Footer />
    </section>
    </main>
  );
}

export default WebDesignPortfolio;